import { MatchProps } from "preact-iso";

/**
 * Executes a route match against a URL and a route pattern.
 * Returns a MatchProps object if the URL matches the route pattern,
 * or null if it does not match.
 * This function not exported by Preact ISO, but we need it for our router.
 * @link https://github.com/preactjs/preact-iso/blob/82cdde49b8cd7584a5bcf193a033d46433a81490/src/router.js#L66
 */
export const exec = (originUrl: string, originRoute: string, matches: MatchProps = {} as MatchProps) => {
    const url = originUrl.split('/').filter(Boolean);
    const route = (originRoute || '').split('/').filter(Boolean);
    if (!matches.params) matches.params = {};
    for (let i = 0, val, rest; i < Math.max(url.length, route.length); i++) {
        let [, m, param, flag] = (route[i] || '').match(/^(:?)(.*?)([+*?]?)$/)!;
        val = url[i];
        // segment match:
        if (!m && param == val) continue;
        // /foo/* match
        if (!m && val && flag == '*') {
            matches.rest = '/' + url.slice(i).map(decodeURIComponent).join('/');
            break;
        }
        // segment mismatch / missing required field:
        if (!m || (!val && flag != '?' && flag != '*')) return null;
        rest = flag == '+' || flag == '*';
        // rest (+/*) match:
        if (rest) val = url.slice(i).map(decodeURIComponent).join('/') || undefined;
        // normal/optional field:
        else if (val) val = decodeURIComponent(val);
        matches.params[param] = val!;
        if (!(param in matches)) matches[param] = val;
        if (rest) break;
    }
    return matches as MatchProps;
}